/**
 * Utility functions for reading login data from local storage
 */

export interface LoginData {
  Authorization?: string;
  userId?: number;
  userID?: number;
  userName?: string;
  loginTimestamp?: string;
  [key: string]: any; // Allow for additional fields from login response
}

/**
 * Get the complete login data from local storage
 */
export const getLoginData = (): LoginData | null => {
  try {
    const data = localStorage.getItem('loginData');
    if (data) {
      return JSON.parse(data) as LoginData;
    }
  } catch (error) {
    console.error('Error parsing login data from local storage:', error);
  }
  return null;
};

/**
 * Get the user ID from local storage
 * Tries multiple field names to handle different API response formats
 */
export const getUserIdFromSession = (): number | null => {
  const loginData = getLoginData();
  if (loginData) {
    // Try different possible field names for user ID
    return loginData.userId ?? loginData.userID ?? loginData.UserId ?? loginData.UserID ?? null;
  }
  return null;
};

/**
 * Get the username from local storage
 */
export const getUserNameFromSession = (): string | null => {
  const loginData = getLoginData();
  if (loginData) {
    return loginData.userName ?? loginData.UserName ?? null;
  }
  return null;
};
